import { Component, OnInit } from '@angular/core';
import { companyInfo } from 'src/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  public text= companyInfo;
}
